<ng-template #operationConfirm></ng-template>